import { Link } from 'react-router-dom';
import { ArrowRight, Award, CheckCircle } from 'lucide-react';
import './Events.css';

const events = [
  {
    emoji: '🏢',
    title: 'Corporate Events',
    desc: 'The finest bands for corporate occasions — delivering premium entertainment that leaves a lasting impression on employees and clients alike.',
    features: ['Professional setup', 'Custom setlists', 'All genres', 'Sound & lighting'],
  },
  {
    emoji: '🎂',
    title: 'Birthday Parties',
    desc: 'Celebrate your birthday at any age with a live Rock Band, DJ & Karaoke party. We make every birthday an unforgettable milestone.',
    features: ['All age groups', 'Karaoke included', 'DJ available', 'Custom themes'],
  },
  {
    emoji: '💍',
    title: 'Anniversary Parties',
    desc: 'Surprise your loved one with a live music concert for your Anniversary Party. Create moments that last a lifetime.',
    features: ['Romantic setlists', 'Surprise planning', 'Intimate setup', 'Special dedications'],
  },
  {
    emoji: '💒',
    title: 'Receptions',
    desc: 'The best live wedding bands for unforgettable receptions. We create the perfect musical backdrop for your most special day.',
    features: ['Wedding specialists', 'Traditional & modern', 'Sangeet available', 'Full evening coverage'],
  },
  {
    emoji: '🏠',
    title: 'Family Get Together',
    desc: 'A live band or musical duo can have everyone on the dance floor. Perfect for family reunions, festivals, and house parties.',
    features: ['Multi-generational', 'Folk & Bollywood', 'Flexible duration', 'Outdoor capable'],
  },
  {
    emoji: '🍷',
    title: 'Café / Lounge / Bars',
    desc: 'We work with venues of all sizes, from local pubs, cafés and bars to upscale restaurants and lounges.',
    features: ['Ambient performances', 'Compact setups', 'Regular bookings', 'Flexible hours'],
  },
];

const awards = [
  'Best Versatile Band of Jaipur — 4.8/5 Google Rating',
  'Google Certified Service Provider',
  'Awarded by various Organizations and Army Units',
  'Felicitated by NCC 1 Raj Girls Battalion Jaipur',
  '4x Certificate of Excellence — Govt. of Rajasthan',
  'Commendations by Dept. of Archaeology & Museums (2015, 2016, 2018)',
  'Felicitated by IBPC Sharjah, UAE (2017)',
  'Felicitated by Indian Business Alliance (SITA) Moscow (2018)',
  'Grand Orchestra — World Cultural Festival, Art of Living (2016)',
  'Runner-up Zee Aa Se Antakshiri — Zee TV',
  'Awarded by Rotary Club Jaipur',
  'Performed 1500+ Musical Shows all over India',
];

export default function Events() {
  return (
    <div className="events-page">
      <div className="page-hero">
        <span className="breadcrumb">Home / <span>Events & Parties</span></span>
        <h1>Events & Parties</h1>
      </div>

      {/* Intro */}
      <section className="events-intro">
        <div className="container events-intro-inner">
          <div>
            <span className="section-tag">Our Specializations</span>
            <h2 className="section-title">We Play For Every Occasion</h2>
            <div className="red-line" />
            <p className="section-subtitle">
              Spreading melodies across the world with energetic music that leaves everyone feeling good and wanting for more.
            </p>
          </div>
        </div>
      </section>

      {/* Events Grid */}
      <section className="events-grid-section">
        <div className="container">
          <div className="events-grid">
            {events.map((e, i) => (
              <div key={e.title} className="event-card animate-fadeInUp" style={{ animationDelay: `${i * 0.08}s` }}>
                <div className="event-emoji">{e.emoji}</div>
                <h3>{e.title}</h3>
                <p>{e.desc}</p>
                <ul className="event-features">
                  {e.features.map(f => (
                    <li key={f}><CheckCircle size={14} /> {f}</li>
                  ))}
                </ul>
                <Link to="/contact" className="btn-primary" style={{ marginTop: 'auto' }}>
                  Book Now <ArrowRight size={16} />
                </Link>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Music CTA */}
      <section className="music-cta">
        <div className="music-cta-bg" />
        <div className="container music-cta-inner">
          <h2>Relax and Enjoy Our Live Music Concert</h2>
          <p>
            Music plays a unique role at an event. It creates atmosphere and ambiance. It influences your guests' moods and makes them feel comfortable. The right music helps people relax and enjoy a memorable experience.
          </p>
          <Link to="/contact" className="btn-outline">Explore All Events <ArrowRight size={16} /></Link>
        </div>
      </section>

      {/* Awards */}
      <section className="events-awards">
        <div className="container">
          <div style={{ textAlign: 'center', marginBottom: 48 }}>
            <span className="section-tag">Recognition</span>
            <h2 className="section-title">Awards & Accolades</h2>
            <div style={{ width: 60, height: 3, background: 'var(--red)', margin: '12px auto 0' }} />
          </div>
          <div className="awards-masonry">
            {awards.map((a, i) => (
              <div key={i} className="award-entry animate-fadeInUp" style={{ animationDelay: `${i * 0.05}s` }}>
                <Award size={16} />
                <span>{a}</span>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
